(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-sticky-cart"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mb-sticky-cart')) {
  customElements.define('mb-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-bar-variant]');
      this.qty = this.querySelector('[name="quantity"]');
      this.submit = this.querySelector('[name="add"]');
      this.label = this.querySelector('[data-add-label]');
      this.main = document.getElementById('tzp');
      this.mainQty = document.getElementById('tzp-qty');
      this.mainAdd = this.main?.querySelector('[data-add]');
      this.syncVariant = () => {
        const id = this.mainAdd?.getAttribute('data-tzbuy');
        if (id && Array.from(this.select.options).some(option => option.value === id)) this.select.value = id;
        this.updateButton();
        if (this.mainAdd?.disabled) this.submit.disabled = true;
      };
      this.syncQuantity = () => { if(this.mainQty) this.qty.value = this.mainQty.value; };
      this.onVariant = () => this.syncVariant();
      document.addEventListener('kc:variant-change', this.onVariant);
      this.select.addEventListener('change', () => {
        document.dispatchEvent(new CustomEvent('kc:select-variant', {detail:{id:this.select.value}}));
        this.updateButton();
      });
      this.onQuantity = () => this.syncQuantity();
      this.main?.addEventListener('input', this.onQuantity);
      this.main?.addEventListener('click', this.onQuantity);
      this.qty.addEventListener('input', () => { if(this.mainQty) this.mainQty.value = this.qty.value; });
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
        this.qty.value = Math.max(1, (parseInt(this.qty.value, 10) || 1) + Number(button.dataset.step));
        if(this.mainQty) this.mainQty.value = this.qty.value;
      }));
      this.syncVariant();
      this.syncQuantity();
      this.resizeObserver = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--mb-buybar-height', Math.ceil(this.getBoundingClientRect().height) + 'px');
      });
      this.resizeObserver.observe(this);
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.hidden = entries.some(entry => entry.isIntersecting);
      }, {threshold:0});
      const controls = this.main?.querySelector('[data-buy]') || document.querySelector('main .shopify-payment-button');
      if(controls) this.visibilityObserver.observe(controls);
    }
    updateButton() {
      const available = this.select.selectedOptions[0]?.dataset.available === 'true';
      this.submit.disabled = !available;
      this.label.textContent = available ? this.label.dataset.add : this.label.dataset.sold;
    }
    disconnectedCallback() {
      document.removeEventListener('kc:variant-change', this.onVariant);
      this.main?.removeEventListener('input', this.onQuantity);
      this.main?.removeEventListener('click', this.onQuantity);
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      document.documentElement.style.removeProperty('--mb-buybar-height');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
